import { IContentDefinition, IOnlineCredits, ODSAlertTones } from '../../typings';

export const createOnlineCreditsBoxContent = (
  planTone: ODSAlertTones,
  heading: string,
  content: string
): IContentDefinition<IOnlineCredits> => {
  const creditsConfig = { heading: heading, content: content, tone: planTone };

  return {
    // new way of organising content using a flat structure with tags rather than a hierarchical structure,
    // both structures can co-exist with one another but preference is given to this new way of classifying and finding content,
    // note: order of contents matters because the first matching record is returned
    contents: [
      {
        data: undefined,
        tags: ['connection:scenario:cust_prch'],
      },
      {
        data: undefined,
        tags: ['state:act', 'state:vic', 'state:wa'],
      },
      {
        data: creditsConfig,
        tags: ['fuel:dual', 'fuel:electricity'],
      },
    ],
  } as IContentDefinition<IOnlineCredits>;
};
